import React from "react"
import PropTypes from "prop-types"
import { Switch } from "react-router"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { getTranslate, getActiveLanguage } from "react-localize-redux"
import { TransitionGroup, CSSTransition } from "react-transition-group"

import "../helpers/polyfills"
import { Routes, PrivateRoutes, SharedRoutes, PublicRoutes } from "../configs"
import PrivateRoute from "./components/routes/PrivateRoute"
import RouteWithSubRoutes from "./components/routes/RouteWithSubRoutes"
import PublicRoutesRoute from "./components/routes/PublicRoutesRoute"
import Layout from "./layout/Layout"
import EgiftLayout from "./layout/EgiftLayout"
import PrivateLayout from "./layout/PrivateLayout"

class App extends React.Component {
	render() {
		const {
			currentLanguage,
			isAuthenticated,
			location,
			keepLogin,
			userInfoAutoFill,
		} = this.props
		const _t = location.pathname.split("/")
		if (
			_t[2] &&
			(_t[2] === "egift" || _t[2] === "landing-egift" || _t[2] === "voucher")
		) {
			return (
				<EgiftLayout {...this.props}>
					<TransitionGroup>
						<CSSTransition key={location.key} classNames="fade" timeout={250}>
							<Switch location={location}>
								{PublicRoutes.map((route, index) => (
									<PublicRoutesRoute
										key={index}
										{...route}
										isAuthenticated={isAuthenticated}
										currentLanguage={currentLanguage}
										userInfoAutoFill={userInfoAutoFill}
									/>
								))}
							</Switch>
						</CSSTransition>
					</TransitionGroup>
				</EgiftLayout>
			)
		} else {
			return (
				<Layout {...this.props}>
					{isAuthenticated === false && (
						<TransitionGroup>
							<CSSTransition
								key={location.key}
								classNames="fade"
								timeout={250}>
								<Switch location={location}>
									{Routes.map((route, index) => (
										<RouteWithSubRoutes
											key={index}
											{...route}
											isAuthenticated={isAuthenticated}
											currentLanguage={currentLanguage}
										/>
									))}
									{PrivateRoutes.map((route, index) => (
										<PrivateRoute
											key={index}
											{...route}
											isAuthenticated={isAuthenticated}
											currentLanguage={currentLanguage}
											keepLogin={keepLogin}
										/>
									))}
									{SharedRoutes.map((route, index) => (
										<RouteWithSubRoutes
											key={index}
											{...route}
											isAuthenticated={isAuthenticated}
											currentLanguage={currentLanguage}
										/>
									))}
								</Switch>
							</CSSTransition>
						</TransitionGroup>
					)}
					{isAuthenticated === true && (
						<PrivateLayout {...this.props}>
							<TransitionGroup>
								<CSSTransition
									key={location.key}
									classNames="fade"
									timeout={250}>
									<Switch location={location}>
										{PrivateRoutes.map((route, index) => (
											<PrivateRoute
												key={index}
												{...route}
												isAuthenticated={isAuthenticated}
												currentLanguage={currentLanguage}
												keepLogin={keepLogin}
											/>
										))}
										{Routes.map((route, index) => (
											<RouteWithSubRoutes
												key={index}
												{...route}
												isAuthenticated={isAuthenticated}
												currentLanguage={currentLanguage}
											/>
										))}
										{SharedRoutes.map((route, index) => (
											<PrivateRoute
												key={index}
												{...route}
												isAuthenticated={isAuthenticated}
												currentLanguage={currentLanguage}
											/>
										))}
									</Switch>
								</CSSTransition>
							</TransitionGroup>
						</PrivateLayout>
					)}
				</Layout>
			)
		}
	}
}

App.propTypes = {
	isAuthenticated: PropTypes.bool.isRequired,
	location: PropTypes.object.isRequired,
	match: PropTypes.object.isRequired,
	translate: PropTypes.func.isRequired,
	currentLanguage: PropTypes.string.isRequired,
}

const mapStateToProps = ({ auth, locale, router }) => ({
	isAuthenticated: auth.isAuthenticated,
	keepLogin: auth.keepLogin,
	translate: getTranslate(locale),
	location: router.location,
	currentLanguage: getActiveLanguage(locale).code,
	userInfoAutoFill: auth.userInfoAutoFill,
})

export default withRouter(connect(mapStateToProps)(App))
